<div class="radio-group-container"
     [ngClass]="{'has-errors': hasErrors}">
  <boi-validation-error-generic (errorChange)="onErrorChange($event)"
                                [validationErrors]="validationErrors"
                                [propertyNames]="validationPropertyNames">
  </boi-validation-error-generic>

  <kendo-textbox-container>
    <div [ngClass]="cssClasses"
         class="field-container">
      <div *ngIf="radioButtonGroupLabel || (labelName | localizeLabel)"
           class="field-label"
           [boiRequiredFormField]="required ? labelName : undefined">
        <label [for]="controlId ? controlId : labelName">
          <span [innerHtml]="radioButtonGroupLabel ? radioButtonGroupLabel : (labelName | localizeLabel)"></span>
          <boi-tooltip *ngIf="!isTooltipLast && showTooltip"
                       [tooltipName]="tooltipName ? tooltipName : labelName"
                       class="tooltip">
          </boi-tooltip>
        </label>
      </div>
      <div class="field-input">
        <ng-container *ngIf="availableOptions; else optionListTemplate">
          <label *ngFor="let item of availableOptions; let index = index"
                 class="radio-input">
            <input [attr.name]="controlId ? controlId : labelName"
                   [name]="controlId ? controlId : labelName"
                   type="radio"
                   class="form-radio-button"
                   [(ngModel)]="value"
                   [disabled]=" isFieldDisabled || disabledOptionCodes.indexOf(item[valueField]) > -1"
                   [id]="controlId ? controlId + index : labelName + index"
                   [value]="item[valueField]"
                   [required]="required" />
            <span class="label"
                  *ngIf="textField"
                  [innerHTML]="item[textField]"></span>
          </label>
        </ng-container>
        <ng-template #optionListTemplate>
          <label *ngFor="let option of (optionList | localizeOptionList); let index = index"
                 class="radio-input">
            <input [attr.name]="controlId ? controlId : labelName"
                   [name]="controlId ? controlId : labelName"
                   type="radio"
                   class="form-radio-button"
                   [(ngModel)]="value"
                   [disabled]="isFieldDisabled || disabledOptionCodes.indexOf(option.Code) > -1"
                   [id]="controlId ? controlId + index : labelName + index"
                   [value]="option.Code"
                   [required]="required" />
            <span class="label"
                  [innerHTML]="option.Value"></span>
          </label>
        </ng-template>
        <boi-tooltip *ngIf="isTooltipLast && showTooltip"
                     [tooltipName]="tooltipName ? tooltipName : labelName"
                     class="tooltip">
        </boi-tooltip>
      </div>
    </div>
  </kendo-textbox-container>
</div>